module.exports = __webpack_public_path__ + "img/product-list_m6.1b8ec9a2.png";